// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j5xwTzT0XTYvqnPq{justify-content:center;width:100%}.j5xwTzT0XTYvqnPq .bcmZ40ba1cEdNSa3{margin:auto;width:656px;vertical-align:middle;overflow-wrap:break-word;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `j5xwTzT0XTYvqnPq`,
	"name": `bcmZ40ba1cEdNSa3`
};
export default ___CSS_LOADER_EXPORT___;
